// src/theme/tokens/index.js
// Faz 1 · Tum yeni token dosyalarini barrel export ile birlestirir.
// theme/index.js bu dosyadan import edip extendTheme'e merge eder.
//
// AGGREGATION KURALLARI:
//   - colors: paletteExtensions, mevcut colors.js'in UZERINE deep-merge edilir
//             (mevcut anahtarlar korunur, brand altinda yeni alpha'lar eklenir)
//   - semanticTokens.colors: tum exam.* / srs.* / chart.* / marketing.* /
//             reading.* / state.* / surface.* token'lari merge edilir
//   - semanticTokens.shadows: focusRing.* + elevation.shadows merge edilir
//   - fonts/fontSizes/letterSpacings/lineHeights/fontWeights: extension'lar merge edilir

import paletteExtensions from './palette';
import examTokens from './exam';
import srsTokens from './srs';
import chartTokens, { CHART_SERIES } from './chart';
import elevation from './elevation';
import focusRingTokens from './focusRing';
// gradient.js ve marketing.js icerikleri Faz 4'te kullanilmadigi icin temizlendi
// (tum tokenler sifir kullanimla cope edildi). Dosyalar bos namespace olarak duruyor.
import gradientTokens from './gradient';
import marketingTokens, { MARKETING_WORD_TOKENS } from './marketing';
import readingTokens from './reading';
import { stateTokens } from './state';
// density.js ic preset objesi kaldirildi (sifir Faz 2 wiring); modul bos export saglar.
import density from './density';
import state from './state';
import motion, { motionCssVars, motionPresets } from './motion';
import highlightTokens from './highlight';
import hubTokens from './hub';
// typographySemantics objesi kaldirildi (sifir importer); diger uzantilar aktif.
import {
  fontsExtension,
  fontSizesExtension,
  letterSpacingsExtension,
  lineHeightsExtension,
  fontWeightsExtension,
  fontFeatures,
} from './typography';

// Tum semantic color token'larini tek bir map'te birlestir.
const semanticColors = {
  ...examTokens,
  ...srsTokens,
  ...chartTokens,
  ...gradientTokens,
  ...marketingTokens,
  ...readingTokens,
  ...stateTokens,
  ...elevation.surfaces,
  ...highlightTokens,
  ...hubTokens,
};

// Tum semantic shadow token'larini tek bir map'te birlestir.
const semanticShadows = {
  ...elevation.shadows,
  ...focusRingTokens,
};

// Typography extension'lari (extendTheme'e dogrudan eklenir).
const typographyExtensions = {
  fonts: fontsExtension,
  fontSizes: fontSizesExtension,
  letterSpacings: letterSpacingsExtension,
  lineHeights: lineHeightsExtension,
  fontWeights: fontWeightsExtension,
};

const tokens = {
  paletteExtensions,
  semanticColors,
  semanticShadows,
  typographyExtensions,
  fontFeatures,
  density,
  state,
  motion,
  motionCssVars,
  motionPresets,
  highlightTokens,
  CHART_SERIES,
  MARKETING_WORD_TOKENS,
};

export default tokens;
export {
  paletteExtensions,
  semanticColors,
  semanticShadows,
  typographyExtensions,
  fontFeatures,
  density,
  state,
  motion,
  motionCssVars,
  motionPresets,
  highlightTokens,
  CHART_SERIES,
  MARKETING_WORD_TOKENS,
};
